/**
 * Constants for Set Cleaning Standards page (Step 3).
 * Single source of truth: query scope, copy, wizard, layout, and error messages.
 * Open/Closed: add new copy or messages here without changing components.
 */

export const QUERY_SCOPE = 'cleaning-standards';

export const PAGE_COPY = {
  TITLE: 'Set Up Cleaning Standards',
  FACILITY_STANDARDS_HEADING: 'Set Facility Standards',
  LOCATIONS_STANDARDS_HEADING: 'Set Areas Standards',
  EMPTY_FACILITIES_MESSAGE:
    'No facilities found. Please go back to Step 1 to add facilities.',
};

export const WIZARD_STEP = {
  CURRENT: 3,
  TOTAL: 3,
  NAME: 'Cleaning Standards',
  CONTINUE_TEXT: 'Back to overview',
};

/** Shared panel card styles for facilities and standards columns */
export const PANEL_CARD_CLASS =
  'bg-white rounded-[20px] border border-[#d3d6dc] shadow-[0px_2px_10px_0px_rgba(0,0,0,0.15)]';

/** User-facing error messages for facility actions */
export const ERROR_MESSAGES = {
  ADD_FACILITY: 'Failed to create facility. Please try again',
  UPDATE_FACILITY: 'Failed to update facility. Please try again',
};

/** Toast configuration */
export const TOAST_CONFIG = {
  SUCCESS_DURATION_MS: 3000,
  ERROR_DURATION_MS: 4000,
  TITLE_SUCCESS: 'Success',
  TITLE_ERROR: 'Error',
};
